import { EdgeAddChannelMembersRepository } from '@/modules/connect/infra'
import type { AddChannelMembers } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeAddChannelMembers(): AddChannelMembers {
  return new EdgeAddChannelMembersRepository(makeSupabaseEdgeHttpClient()).execute
}
